<template>
  <div v-editable="blok" class="em-map container-full">
    <div class="head-container">
      <ItemContentHead
        v-if="blok.head?.[0]?.component === 'item_content-head'"
        class="head"
        :blok="blok.head[0]"
        :headSize="blok.head_size"
        :isDark="blok.is_dark" />
    </div>
    <SharedEMMapBase
      :brand="Brand.WMF"
      :mapStyles="mapStyles"
      mapBackgroundColor="#0D0D0D"
      :initialZoom="5.6"
      :fallbackImageMobile="blok.fallback_image_mobile"
      :fallbackImageDesktop="blok.fallback_image_desktop"
      :storeContactType="blok.store_contact_type"
      :googleMapsApiKeyPublic="config.public.GOOGLE_MAPS_API_KEY_PUBLIC"
      :buttonLink="blok.button_link"
      :translations="{
        consentText: t('EMMap.consentText'),
        consentButtonLabel: t('EMMap.consentButtonLabel'),
        errorOccurred: t('global.errorOccurred'),
        atLeast4Characters: t('EMMapSearchInput.atLeast4Characters'),
        searchInputPlaceholder: t('EMMapSearchInput.placeholder'),
        otherCountryInfo: t('EMMapResultsLayer.otherCountryInfo'),
        differentCountry: t('EMMapResultsLayer.differentCountry'),
        locationNotFound: t('useGoogleMaps.locationNotFound'),
        yourLocation: t('EMMapSearchInput.yourLocation'),
      }">
      <template #modal>
        <EMMapModal />
      </template>

      <template #load-more-button>
        <UtilButton
          :blok="{
            component: 'util_button',
            text: t('global.loadMore'),
            size: 'large',
            theme: 'secondary',
            _uid: 'load-more',
          }"
          :isBackgroundDark="true"
          class="mobile-button"
          @click="handleLoadMore" />
      </template>

      <template #contact-form-button>
        <UtilButton
          v-if="blok.store_contact_type === 'button' && blok.button_link"
          class="contact-button"
          :blok="{
            component: 'util_button',
            theme: 'primary',
            text: t('EMMapResult.contactButtonLabel'),
            size: 'small',
            link: blok.button_link,
            _uid: 'button-contact-form',
          }" />
      </template>
    </SharedEMMapBase>
  </div>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#imports';
import { useI18n } from 'vue-i18n';
import { SharedEMMapBase } from '@seb-platform/shared/components/storyblok';
import { Brand, SebEvent } from '@seb-platform/shared/types/utils';
import ItemContentHead from '~/components/storyblok/item/ItemContentHead/ItemContentHead.vue';
import UtilButton from '~/components/storyblok/utils/UtilButton/UtilButton.vue';
import type { EmMapStoryblok } from '~/types/storyblok-generated';
import EMMapModal from './EMMapModal.vue';
import { mapStyles } from './map-styles';

defineProps<{ blok: EmMapStoryblok }>();

const config = useRuntimeConfig();
const { t } = useI18n();

function handleLoadMore() {
  document.dispatchEvent(new CustomEvent(SebEvent.EmMapLoadMore));
}
</script>

<style src="./EMMap.scss" lang="scss" scoped />
